import type { RegistryEntry, UiOptionInput, UiOptionNumber } from '../../types';

const IMAGEN_SEED_OPTION = {
  key: 'seed',
  label: 'Seed',
  type: 'number',
  min: 0,
  max: 2147483647,
  step: 1,
  group: 'basic',
} as UiOptionNumber;

const IMAGEN_NEGATIVE_PROMPT_OPTION = {
  key: 'negative_prompt',
  label: 'Negative Prompt',
  type: 'input',
  default: '',
  group: 'basic',
} as UiOptionInput;

const toImagenProviderOptions = (ui: Record<string, any>) =>
  ({
    seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
    negative_prompt:
      typeof ui.negative_prompt === 'string' && ui.negative_prompt.trim()
        ? ui.negative_prompt.trim()
        : undefined,
  }) as unknown as Record<string, Record<string, any>>;

const imagenEntry: RegistryEntry = {
  options: [IMAGEN_SEED_OPTION, IMAGEN_NEGATIVE_PROMPT_OPTION],
  toProviderOptions: toImagenProviderOptions,
};

export const imagenConfigs: Record<string, RegistryEntry> = {
  'google/imagen4-ultra': imagenEntry,
  'google/imagen4': imagenEntry,
  'google/imagen4-fast': imagenEntry,
};